import React from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { Button } from "@/components/ui/button";
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "@/components/ui/card";
// import { GoogleIcon, LineIcon } from '@/components/icons';
import GoogleIcon from '@/components/icons/Google';

export const SignupPage: React.FC = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  // Placeholder OAuth handlers
  const handleGoogleSignup = () => {
    console.log("Attempting Google Signup...");
    window.location.href = `/auth/google/login?returnTo=${searchParams.get("returnTo")}`;
  };

  const handleLineSignup = () => {
    console.log("Attempting Line Signup...");
    alert("Line Signup not implemented yet.");
  };

  const handleLoginRedirect = () => {
    navigate("/login"); // Go back to login page
  };

  return (
    <div className="flex min-h-screen items-center justify-center bg-neutral-900 p-4">
      <Card className="w-full max-w-sm bg-neutral-800 border-neutral-700 text-white">
        <CardHeader className="text-center">
          <CardTitle className="text-2xl font-thin uppercase tracking-[4px] text-chotto-gold">
            Join Chotto
          </CardTitle>
          <CardDescription className="text-neutral-400">
            Sign up using your preferred service
          </CardDescription>
        </CardHeader>
        <CardContent className="space-y-4">
          <Button
            onClick={handleGoogleSignup}
            className="w-full bg-white text-black hover:bg-neutral-200"
          >
            <GoogleIcon className="mr-2 h-5 w-5" />
            Sign up with Google
          </Button>
          {/* <Button
            onClick={handleLineSignup}
            className="w-full bg-[#00B900] text-white hover:bg-[#00a300]"
          >
            <LineIcon className="mr-2 h-5 w-5" />
            Sign up with Line
          </Button> */}

          {/* Optional: Add Email/Password signup later */}

          <p className="text-center text-sm text-neutral-400">
            Already have an account?{" "}
            <Button
              variant="link"
              className="p-0 h-auto text-chotto-gold"
              onClick={handleLoginRedirect}
            >
              Log In
            </Button>
          </p>
        </CardContent>
      </Card>
    </div>
  );
};
